import { getDateString } from "@website-builder/utilities-index";

export default ({
	coverImage = {},
	title = "",
	featuredDescription = "",
	dateOfPublishing = "",
	isIndexPage = false,
	slug = "",
	bannerImageSizes,
}) => {
	return {
		coverImage: {
			image: coverImage?.[0]?.image?.image,
			alt: coverImage?.[0]?.image?.altTag,
			base64: coverImage?.[0]?.image?.base64,
		},
		title,
		featuredDescription,
		dateOfPublishing: getDateString(dateOfPublishing),
		isIndexPage,
		link: `/${slug}`,
		bannerImageSizes,
	};
};
